@if (dialogData && showButton) {
  <app-icon-button [icon]="closeIcon" (click)="close()" [border]="false"></app-icon-button>
}
@if (categories$ | async) {
  <section class="categories">
    <ul>
      @let ancestor = getCategoryAncestor();
      @if (ancestor) {
        <li class="ancestor-category" [class.selected]="ancestor.id === currentCategoryId">
          <a [routerLink]="getCategoryUrl(ancestor.id)" queryParamsHandling="merge">{{ allProducts }}</a>
        </li>
      }
      @if (currentCategories?.length > 1) {
        @for (category of currentCategories; track category.data.id) {
          <li class="current-category" [class.selected]="category.data.id === currentCategoryId">
            <a (click)="clickCategory()" [routerLink]="getCategoryUrl(category.data.id)" queryParamsHandling="merge">
              {{ category.data.name }}
            </a>
          </li>
        }
      }

      @if (childCategories) {
        @for (category of childCategories; track category.data.id) {
          <li class="child-category">
            <a
              (click)="clickCategory()"
              [routerLink]="getCategoryUrl(category.data.id)"
              queryParamsHandling="merge"
              [class.selected]="category.data.id === currentCategoryId"
            >
              {{ category.data.name }}
            </a>
          </li>
        }
      }
    </ul>
  </section>
}
